import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AttiFormComponent } from '../../../form/atti-form.component';
import { Atto } from '../../../models/atto';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneAttiFull } from '../../../models/sezioni/sezione-atti-full';

@Component({
    selector: 'div [atti-form-modify]',
  templateUrl: '../../../form/atti-form.component.html'
})

export class AttiModifyConcreteFormComponent extends AttiFormComponent {
  atto: Atto;
  sezione: SezioneAttiFull;
  urlUpdate: string;
  fascicolo!: FascicoloFull;
  @Output() onReturn: EventEmitter<SezioneAttiFull> = new EventEmitter<SezioneAttiFull>();
  @Output() attoMod: EventEmitter<Atto> = new EventEmitter<Atto>();
  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica Atto');
    this.isInserimento(false);
  }

  getAtto() {
    return this.atto;
  }

  getRequest(attiAdapter: Atto) {
    this.operationService.updateAtto(this.urlUpdate, attiAdapter, this.sezione.id).subscribe(response => this.datiAtto(response));
  }

  getFascicolo() {
    return this.fascicolo;
  }

  datiAtto(response: any) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response);
      this.attoMod.emit(this.request);
    }
  }

  inizializza(sezione: SezioneAttiFull, atto: Atto, fascicolo: FascicoloFull, urlUpdate: string) {
    this.sezione = sezione;
    this.atto = atto;
    this.urlUpdate = urlUpdate;
    this.fascicolo = fascicolo;
    // this.populateSelect();
    this.createForm(true);
  }

}
